import React from 'react';
import MutliSelect from 'react-select';
import { Controller } from 'react-hook-form';

const SearchableMultiSelect = ({
  label,
  name,
  values,
  control,
  placeholder,
  className,
  rules,
}) => {
  return (
    <div className={className}>
      <label>{label}</label>
      <Controller
        name={name}
        control={control}
        rules={{ required: true }}
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <MutliSelect
              options={values}
              placeholder={placeholder}
              isMulti={true}
              onChange={(options) => onChange(options)}
              onBlur={onBlur}
              value={values.filter((option) => value?.value === option.value)}
              defaultValue={values.filter(
                (option) => value?.value === option.value
              )}
            />
          );
        }}
      />
    </div>
  );
};

export default SearchableMultiSelect;
